import * as React from 'react';
import { OutlinedButton, FilledButton } from '@ds/react-components';
import PropTypes from 'prop-types';
import { Dialog, withStyles } from '@material-ui/core';
import * as Styled from './SsoGroupDeleteMessage.styled';

const styles = (theme) => ({
  groupName: {
    fontWeight: 'bold',
  },
});

const SsoGroupDeleteConfirmDialog = (props) => {
  const { classes, groupName, isOpen, onDelete, onClose } = props;

  return (
    <Dialog maxWidth="xs" onClose={onClose} open={isOpen}>
      <Styled.TitleContainer>
        <Styled.Title>{'Delete group?'}</Styled.Title>
      </Styled.TitleContainer>
      <Styled.ContentContainer>
        <Styled.Content>
          <span>Are you sure you want to permanently delete this group</span>
          <span className={classes.groupName}>{' ' + groupName}</span>
          <span>?</span>
        </Styled.Content>
        <Styled.Content>
          Users who are associated with this group will permanently lose
          permissions once deleted.
        </Styled.Content>
      </Styled.ContentContainer>
      <Styled.FooterContainer>
        <FilledButton variant="error" onClick={onDelete}>
          Delete
        </FilledButton>
        <OutlinedButton variant="slighter" onClick={onClose}>
          Cancel
        </OutlinedButton>
      </Styled.FooterContainer>
    </Dialog>
  );
};

SsoGroupDeleteConfirmDialog.propTypes = {
  groupName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(SsoGroupDeleteConfirmDialog);
